import React, { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid, filterParams, filters, gridConstants as gc } from '../../AgGrid';
import classnames from 'classnames';
import { AppContext } from '../../../AppContext';

// SERVICES
import { getInspectors } from '../../../services';

const styles = theme => ({});

export const InspectorUsersGrid = withStyles(styles)(props => {
  const { classes } = props;
  const { state: { roles } } = useContext(AppContext);

  const [inspectorData, setInspectorData] = useState(null);
  console.log(inspectorData);
  const columnDefinitions = [
    { headerName: 'Name', field: 'name' },
    // {
    //   headerName: 'Account Code',
    //   field: 'accountStatus.code',
    //   filter: filters.set,
    // },
    {
      headerName: 'Open Orders',
      field: 'activeOrders',
      filter: filters.number
    },
    {
      headerName: 'Submitted 14 Days',
      field: 'submitted14',
      filter: filters.number
    },
    {
      headerName: 'Submitted 30 Days',
      field: 'submitted30',
      filter: filters.number
    },
    {
      headerName: 'Accepted Orders',
      field: 'acceptedOrders',
      filter: filters.number,
    },
    {
      headerName: 'Assigned Orders',
      field: 'assignedOrders',
      filter: filters.number,
    },
    {
      headerName: 'Complete Orders',
      field: 'completedOrders',
      filter: filters.number,
    },
    { headerName: 'Inspector ID', field: 'id', width: 100 },
    { headerName: 'Email', field: 'email'},
    { headerName: 'Username', field: 'userName'},
    { headerName: 'Code', field: 'code', width: 100 },
    { headerName: 'Record Type', field: 'recordType', width: 150 },
    { headerName: 'Prefix', field: 'prefix', width: 100 },
    { headerName: 'Suffix', field: 'suffix' },
    { headerName: 'Company', field: 'company' },
    {
      headerName: 'Date of Birth',
      field: 'dateOfBirth',
      width: gc.DATE_FIELD_WIDTH,
      filter: filters.date,
    },
    {headerName: 'Address', field: 'address'},
    {headerName: 'City', field: 'city'},
    {headerName: 'State', field: 'state'},
    {headerName: 'Zip', field: 'zip'},
    {
      headerName: 'Last Login',
      field: 'lastLogin',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
    },
    {
      headerName: 'Created On',
      field: 'createdOn',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
    },
    /*
    { headerName: 'Created By', field: 'createdBy', filter: filters.date },
    {
      headerName: 'Modified On',
      field: 'modifiedOn',
      width: gc.DATE_FIELD_WIDTH,
      filter: filters.date,
    },
    { headerName: 'Modified By', field: 'modifiedBy', filter: filters.date }, */
    // {
    //   headerName: 'Toggle Status',
    //   cellRenderer: params => {},
    // },
  ];

  const gridOptions = {};

  const getInspectorsAsync = async () => {
    try {
      const data = await getInspectors();
      setInspectorData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getInspectorsAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={inspectorData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={roles.includes('ADMIN')}
      />
    </div>
  );
});
